export type SearchFilterOption = { id: string; text: string, count?: number }
export type SearchFilterOptionWithFilterName = { id: any; text: any, count?: number, filterName: string }
export type DocActionPayload = { searchType: string, action: string; collectionId: string; docIds: string[]; isBulkAction: boolean }
export type DocActionProgressPayload = { searchType: string, action: string; docIds: string[]; actionProcessing: boolean; bulkActionProcessing: boolean }
export type DocActionResultPayload = { searchType: string, docId: string; fieldValues: Record<string, any> }
export type SaveSearchPayload = { saveSearchNotify: boolean; saveSearchName: string; searchType: string }
export type StandardsSavedSearch = { context: string; params: string };
export type RecentlyViewedDoc = { name: string; link: string };

export interface ISearchState {
  displaySearchBar: boolean;
  "activeCollectionId": string;
  "activeCollectionName": string;
  "activeTab": string;
  "searchResultActive": boolean,
  "nonce": string,
  "filterDefaults": any,
  "recentlyViewedDocs": RecentlyViewedDoc[],

  "standards.allowAdvanceSearch": boolean,
  "standards.displayMoreSearchBarFilters": boolean,
  "standards.mobileAdvanceSearch": boolean,
  "standards.documentNumber": string,
  "standards.publisher": SearchFilterOption[],
  "standards.status": SearchFilterOption[],
  "standards.country": SearchFilterOption[],
  "standards.dataset": SearchFilterOption[],
  "standards.crossReference": string,
  "standards.icsCode": string,
  "standards.descriptorField": SearchFilterOption[],
  "standards.descriptorGroup": SearchFilterOption[],
  "standards.descriptorSubGroup": SearchFilterOption[],
  "standards.language": SearchFilterOption[],
  "standards.year": SearchFilterOption[],
  "standards.searchIn": SearchFilterOption[],
  "standards.result.sort": SearchFilterOption[],
  "standards.result.page": number,
  "standards.result.loading": boolean,
  "standards.resultData": any,
  "standards.savedSearches": StandardsSavedSearch[],

  "standards.facetFilter.publisher": SearchFilterOption[],
  "standards.facetFilter.status": SearchFilterOption[],
  "standards.facetFilter.country": SearchFilterOption[],
  "standards.facetFilter.dataset": SearchFilterOption[],
  "standards.facetFilter.crossReference": string,
  "standards.facetFilter.icsCode": string,
  "standards.facetFilter.descriptorField": SearchFilterOption[],
  "standards.facetFilter.descriptorGroup": SearchFilterOption[],
  "standards.facetFilter.descriptorSubGroup": SearchFilterOption[],
  "standards.facetFilter.language": SearchFilterOption[],
  "standards.facetFilter.year": SearchFilterOption[],
  "standards.facetFilter.searchIn": SearchFilterOption[],
  "standards.facetFilter.searchIn.expanded": boolean,

  "standards.export.selectedFields": string[],
  "standards.export.format": string,
  "standards.export.status": string,
  "standards.export.totalFound": number,

  "collections.allowAdvanceSearch": boolean,
  "collections.displayMoreSearchBarFilters": boolean,
  "collections.mobileAdvanceSearch": boolean,
  "collections.documentNumber": string,
  "collections.collections": SearchFilterOption[],
  "collections.publisher": SearchFilterOption[],
  "collections.companyCollection": SearchFilterOption[],
  "collections.documentType": SearchFilterOption[],
  "collections.status": SearchFilterOption[],
  "collections.tags": SearchFilterOption[],
  "collections.notes": string,
  "collections.icsCode": string,
  "collections.descriptorField": SearchFilterOption[],
  "collections.descriptorGroup": SearchFilterOption[],
  "collections.descriptorSubGroup": SearchFilterOption[],
  "collections.result.sort": SearchFilterOption[],
  "collections.result.page": number,
  "collections.result.loading": boolean,
  "collections.resultData": any,

  "collections.facetFilter.publisher": SearchFilterOption[],
  "collections.facetFilter.status": SearchFilterOption[],
  "collections.facetFilter.documentType": SearchFilterOption[],
  "collections.facetFilter.collections": SearchFilterOption[],
  "collections.facetFilter.companyCollection": SearchFilterOption[],
  "collections.facetFilter.tags": SearchFilterOption[],
  "collections.facetFilter.icsCode": string,
  "collections.facetFilter.descriptorField": SearchFilterOption[],
  "collections.facetFilter.descriptorGroup": SearchFilterOption[],
  "collections.facetFilter.descriptorSubGroup": SearchFilterOption[],
  "collections.facetFilter.notes": string,

  "collections.export.selectedFields": string[],
  "collections.export.format": string,
  "collections.export.status": string,
  "collections.export.totalFound": number,

  "updates.result.sort": SearchFilterOption[],
  "updates.result.page": number,
  "updates.result.recordsPerPage": number,
  "updates.result.loading": boolean,
  "updates.what": SearchFilterOption[],
  "updates.when": SearchFilterOption[],
  "updates.dataset": SearchFilterOption[],
  "updates.publisher": SearchFilterOption[],
  "updates.dateStart": Date | null,
  "updates.dateEnd": Date | null,
  "updates.resultData": any,

  "updates.export.selectedFields": string[],
  "updates.export.format": string,
  "updates.export.status": string,
  "updates.export.totalFound": number,

  "updates.facetFilter.what": SearchFilterOption[],
  "updates.facetFilter.when": SearchFilterOption[],
  "updates.facetFilter.dataset": SearchFilterOption[],
  "updates.facetFilter.publisher": SearchFilterOption[],
  "updates.facetFilter.dateStart": Date | null,
  "updates.facetFilter.dateEnd": Date | null,

  "lookUpOptions.standards.publisher": SearchFilterOption[],
  "lookUpOptions.standards.status": SearchFilterOption[],
  "lookUpOptions.standards.dataset": SearchFilterOption[],
  "lookUpOptions.standards.country": SearchFilterOption[],
  "lookUpOptions.standards.descriptorField": SearchFilterOption[],
  "lookUpOptions.standards.descriptorGroup": SearchFilterOption[],
  "lookUpOptions.standards.descriptorSubGroup": SearchFilterOption[],
  "lookUpOptions.standards.year": SearchFilterOption[],
  "lookUpOptions.standards.language": SearchFilterOption[],
  "lookUpOptions.standards.searchIn": SearchFilterOption[],
  "lookUpOptions.standards.sortOptions": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.publisher": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.status": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.country": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.dataset": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.crossReference": "",
  "lookUpOptions.standards.facetFilter.descriptorField": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.descriptorGroup": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.descriptorSubGroup": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.language": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.year": SearchFilterOption[],
  "lookUpOptions.standards.facetFilter.searchIn": SearchFilterOption[],

  "lookUpOptions.collections.documentType": SearchFilterOption[],
  "lookUpOptions.collections.collections": SearchFilterOption[],
  "lookUpOptions.collections.companyCollection": SearchFilterOption[],
  "lookUpOptions.collections.tags": SearchFilterOption[],
  "lookUpOptions.collections.sortOptions": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.status": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.dataset": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.publisher": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.documentType": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.collections": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.companyCollection": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.tags": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.descriptorField": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.descriptorGroup": SearchFilterOption[],
  "lookUpOptions.collections.facetFilter.descriptorSubGroup": SearchFilterOption[],

  "lookUpOptions.updates.what": SearchFilterOption[],
  "lookUpOptions.updates.publisher": SearchFilterOption[],
  "lookUpOptions.updates.when": SearchFilterOption[],
  "lookUpOptions.updates.dataset": SearchFilterOption[],
  "lookUpOptions.updates.facetFilter.what": SearchFilterOption[],
  "lookUpOptions.updates.facetFilter.publisher": SearchFilterOption[],
  "lookUpOptions.updates.facetFilter.when": SearchFilterOption[],
  "lookUpOptions.updates.facetFilter.dataset": SearchFilterOption[],
  "lookUpOptions.updates.sortOptions": SearchFilterOption[],
  "lookUpOptions.allDescriptorField": SearchFilterOption[],
  "lookUpOptions.allDescriptorGroup": SearchFilterOption[],
  "lookUpOptions.allDescriptorSubGroup": SearchFilterOption[],

}

export interface ISearchGetters {
  [key: string]: any  //
  isResultLoaded(state: ISearchState): (searchType: string) => boolean;
  getResultsRecordTotal(state: ISearchState): (searchType: string) => number;
  getResultSummaryText(state: ISearchState): (searchType: string) => string;
  getResultActionOptions(state: ISearchState): (searchType: string) => { id: string; text: string }[];
  getAbortController(state: ISearchState): (name: string) => AbortController | undefined;
}

export interface ISearchActions {
  clearSearchFacetFilters(this: ISearchStore, searchType: string, ignoreFields: string[]): void
  clearSearchBarFilters(this: ISearchStore, searchType: string, ignoreFields: string[]): void
  removeFilter(this: ISearchStore, key: keyof ISearchState, item: SearchFilterOption): void
  searchUpdates(this: ISearchStore): void
  initStandardSearchBarFilterOptions(this: ISearchStore): void
  searchUpdates(this: ISearchStore): void
  performDocAction(this: ISearchStore, payload: DocActionPayload): void
  setRowActionProgress(this: ISearchStore, payload: DocActionProgressPayload): void
  updateRowActionResult(this: ISearchStore, payload: DocActionResultPayload): void
  toggleSelectItem(this: ISearchStore, payload: { searchType: string; item: any }): void
  selectAllItems(this: ISearchStore, payload: { searchType: string; selectAll: boolean }): void
  getCollectionSearchParams(this: ISearchStore, facetFilter: boolean, pageNo: number): any
  setCollectionSearchResultData(this: ISearchStore, resultData: any): void
  searchCollections(this: ISearchStore, facetFilter: boolean, pageNo: number): void
  resetCollectionsFiltersForMainSearch(this: ISearchStore, facetFilter: boolean): void
  exportCollectionSearchResults(this: ISearchStore): void
  getStandardSearchParams(this: ISearchStore, facetFilter: boolean, pageNo: number): any
  setStandardSearchResultData(this: ISearchStore, resultData: any): void
  searchStandards(this: ISearchStore, facetFilter: boolean, pageNo: number): void
  searchStandardsWithParams(this: ISearchStore, params: any, handleRedirect: boolean): void
  handleRedirect(this: ISearchStore, resultData: any): void
  resetStandardsFiltersForMainSearch(this: ISearchStore, facetFilter: boolean): void
  exportStandardSearchResults(this: ISearchStore): void
  fetchStandardSuggestions(this: ISearchStore, query: string): Promise<SuggestRecord[]>
  searchUpdates(this: ISearchStore, facetFilter: boolean, pageNo: number): void
  resetUpdatesFiltersForMainSearch(this: ISearchStore, facetFilter: boolean): void
  exportUpdatesSearchResults(this: ISearchStore): void
  getUpdatesSearchParams(this: ISearchStore, facetFilter: boolean, pageNo: number): any
  setDefaultTimeRangeForUpdatesSearch(this: ISearchStore, startDate: Date | null, endDate: Date | null): void
  setUpdatesSearchResultData(this: ISearchStore, resultData: any): void
  toggleSearchBar(this: ISearchStore): void;
  loadICSCodeOptions(this: ISearchStore, payload: { field: string; icsCode: SearchFilterOption[], level: number }): Promise<void>;
  saveSearchParamsToHistory(this: ISearchStore, searchContext: string, params: any): void;
  saveSearch(this: ISearchStore, payload: SaveSearchPayload): Promise<void>;
  saveSearchStandards(this: ISearchStore, payload: SaveSearchPayload): Promise<void>;
  saveSearchCollections(this: ISearchStore, payload: SaveSearchPayload): Promise<void>;
  addApiAbortController(this: ISearchStore, name: string): AbortController
  abortApiCall(this: ISearchStore, names: string[]): void
  abortAllApiCalls(this: ISearchStore): void,
}



export const apiEndPointMapping = {
    "metals.mechanicalComposition": "metalsPhysicalProperty",
    "metals.chemicalComposition": "metalsElement",
    "metals.country": "metals_country",
    "metals.form": "metals_form",
    "metalsSupplier.establishmentType": "metals_supplier_establishment_type",
    "metalsSupplier.name": "metals_supplier_name",
    "metalsSupplier.country": "metals_country",
    "metalsSupplier.form": "metals_form",

    "materials.mechanicalProperty": "material_mechanical_properties",
    "materials.physicalProperty": "material_physical_properties",
    "materials.electricalProperty": "material_electrical_properties",
    "materials.impactProperty": "material_impact_properties",
    "materials.processingProperty": "material_processing_properties",
    "materials.thermalProperty": "material_thermal_properties",
    "materials.otherProperty": "material_other_properties",
    "materials.chemicalAnalysis": "material_chemical_analysis[]",
    "materials.formulation": "material_formulation[]",
    "materials.specialCharacteristics": "material_special_char[]",
    "materials.chemicalResistance": "material_chemical_resistance[]",
    "materials.processing": "material_processing[]",
    "materials.description": "material_description",
    "materials.class": "material_class",
    "materials.form": "material_form[]",
    "materials.productType": "material_product_type",
    "materials.additives": "material_additive[]",
    "materialsSupplier.country": "material_supplier_country",

    "standards.publisher": "publisher",
    "standards.country": "country",
    "collections.collections": "colls[]",
    "collections.companyCollection": "dcoll",
    "collections.tags": "tags[]",

    "standards.facetFilter.publisher": "publisher",
    "standards.facetFilter.country": "country",
    "collections.facetFilter.collections": "colls[]",
    "collections.facetFilter.companyCollection": "dcoll",
    "collections.facetFilter.tags": "tags[]",

    "categories.publisher": "publisher",
    "categories.country": "country",
    "updates.publisher": "publisher",

};
export type ApiEndPointMappingKey = keyof typeof apiEndPointMapping;

export type ISearchStore = ISearchState & ISearchGetters & ISearchActions;



export type FilterArrayKeys<T> = {
  [K in keyof T]:
    T[K] extends { id: string; text: string; count?: number }[] ? K :
    T[K] extends string ? K :
    T[K] extends Date | null ? K :
    never
}[keyof T];

export interface SuggestRecord {
  id: string
  value: string
  label: string
  subtitle?: string
}
